import { createReducer } from 'services/reduxHelpers'
import { bookingTypes } from 'reduxModules/actions/BookingActions'

/* ------------- Initial State ------------- */

export const initialState = {
  bookings: [],
  websiteBookings: [],
  departureBookings: [],
  returnBookings: [],
  isLoading: false
}

/* ------------- Hookup Reducers To Types ------------- */

export default createReducer(initialState, {
  [bookingTypes.SUBSCRIBE_DEPARTURE_BOOKINGS_ATTEMPT]: () => ({
    isLoading: true,
  }),
  [bookingTypes.SUBSCRIBE_DEPARTURE_BOOKINGS_SUCCESS]: (_, { data }) => ({
    departureBookings: data,
    isLoading: false
  }),
  [bookingTypes.SUBSCRIBE_DEPARTURE_BOOKINGS_FAILURE]: () => ({
    isLoading: false
  }),

  [bookingTypes.SUBSCRIBE_BOOKINGS_ATTEMPT]: () => ({
    isLoading: true,
  }),
  [bookingTypes.SUBSCRIBE_BOOKINGS_SUCCESS]: (_, { data }) => ({
    bookings: data,
    isLoading: false
  }),
  [bookingTypes.SUBSCRIBE_BOOKINGS_FAILURE]: () => ({
    isLoading: false
  }),

  [bookingTypes.SUBSCRIBE_WEBSITE_BOOKINGS_ATTEMPT]: () => ({
    isLoading: true,
  }),
  [bookingTypes.SUBSCRIBE_WEBSITE_BOOKINGS_SUCCESS]: (_, { data }) => ({
    websiteBookings: data,
    isLoading: false
  }),
  [bookingTypes.SUBSCRIBE_WEBSITE_BOOKINGS_FAILURE]: () => ({
    isLoading: false
  }),

  [bookingTypes.SUBSCRIBE_RETURN_BOOKINGS_ATTEMPT]: () => ({
    isLoading: true,
  }),
  [bookingTypes.SUBSCRIBE_RETURN_BOOKINGS_SUCCESS]: (_, { data }) => ({
    returnBookings: data,
    isLoading: false
  }),
  [bookingTypes.SUBSCRIBE_RETURN_BOOKINGS_FAILURE]: () => ({
    isLoading: false
  }),

  [bookingTypes.CLEAR_BOOKINGS_ATTEMPT]: () => ({
    ...initialState
  }),

  [bookingTypes.CLEAR_RETURN_BOOKINGS_ATTEMPT]: () => ({
    returnBookings: []
  }),
})



// WEBPACK FOOTER //
// ./src/reduxModules/reducers/BookingReducer.js